import { reactive } from 'vue'
import type { Router } from 'vue-router'

interface NavigationState {
  path: string | null
  query: Record<string, any> | null
  pending: boolean
}

export const universalLinkNavigation = reactive<NavigationState>({
  path: null,
  query: null,
  pending: false,
})

let routerInstance: Router | null = null

export function setRouterInstance(router: Router) {
  routerInstance = router
}

export function setPendingNavigation(path: string, query: Record<string, any>) {
  // If router is already available (iOS case), navigate immediately
  if (routerInstance && window.os === 'ios') {
    const currentRoute = routerInstance.currentRoute.value
    const shouldNavigate = currentRoute.path !== path || 
                          JSON.stringify(currentRoute.query) !== JSON.stringify(query)
    
    if (shouldNavigate) {
      console.info('[UL] Immediate navigation (iOS)', { path, query, currentPath: currentRoute.path, currentQuery: currentRoute.query })
      routerInstance.push({ path, query })
      return
    } else {
      console.info('[UL] Already on target route (iOS)', { path, query })
      return
    }
  }
  
  // Otherwise, store for later consumption (Android case)
  universalLinkNavigation.path = path
  universalLinkNavigation.query = query
  universalLinkNavigation.pending = true
  console.info('[UL] Pending navigation (Android)', { path, query })
}

export function consumePendingNavigation() {
  if (universalLinkNavigation.pending) {
    const navigation = {
      path: universalLinkNavigation.path,
      query: universalLinkNavigation.query,
    }
    universalLinkNavigation.path = null
    universalLinkNavigation.query = null
    universalLinkNavigation.pending = false
    return navigation
  }
  return null
}
